export default class Decision {
	constructor(initer) {
		this.initer = initer;
		this.mob = initer.mob;
		this.control = initer.control;
		this.model = initer.model;
		this.tileMap = initer.tileMap;
		this.callback = initer.callback;
		this.id = Decision.ID++;
	}

	execute(payload = null) {
		this.init(payload);
	}

	init() {
		console.log("to override");
	}

	destroy() {
		this.destroyed = true;
		//this.dispatch({ type: Decision.EVENT_TO_REMOVE, data: this });
	}

	accomplished(data = null) {
		this.dispatch({ type: Decision.EVENT_ACCOMPLISHED, data: data });
	}
	inProgress(decision) {
		this.dispatch({ type: Decision.EVENT_IN_PROGRESS, data: decision });
	}

	dispatch(e) {
		if (this.callback) {
			//console.log(this.callback)
			this.callback.call(null, e);
		}
	}




}

Decision.ID = 0;
Decision.EVENT_ACCOMPLISHED = "eventAccomplished";
Decision.EVENT_IN_PROGRESS = "eventInProgress";
Decision.EVENT_TO_REMOVE = "eventToRemove";